// mirror of backend catalog.py pricing so the UI can show a live price instantly
export function computeItemPrice(style, selections) {
  if (!style) return 0;
  let total = Number(style.base_price) || 0;
  for (const grp of style.groups) {
    const val = selections[grp.id];
    if (val == null) continue;
    if (grp.type === "image" || grp.type === "images") continue;
    const priceMap = {};
    grp.options.forEach((o) => { priceMap[o.value] = o.price; });
    if (grp.multi) {
      (Array.isArray(val) ? val : []).forEach((v) => { total += priceMap[v] || 0; });
    } else {
      total += priceMap[val] || 0;
    }
  }
  return Math.round(total * 100) / 100;
}

export function money(n) {
  return "$" + (Number(n) || 0).toFixed(2);
}

export const PAYMENT_META = {
  pending: { label: "Unpaid", color: "#F59E0B" },
  paid: { label: "Paid", color: "#10B981" },
  partially_refunded: { label: "Partly refunded", color: "#6366F1" },
  refunded: { label: "Refunded", color: "#EF4444" },
};

export const STATUS_META = {
  placed: { label: "Order Placed", color: "#9A7E87" },
  received: { label: "Received", color: "#3B82F6" },
  confirmed: { label: "Confirmed", color: "#8B5CF6" },
  preparing: { label: "Being Prepared", color: "#F59E0B" },
  on_route: { label: "On Route", color: "#EC4899" },
  delivered: { label: "Delivered", color: "#10B981" },
};

export const STATUS_ORDER = ["received", "confirmed", "preparing", "on_route", "delivered"];

export const MODE_META = {
  same_day: { label: "Same-Day", blurb: "Ready today (Pickup only)" },
  next_day: { label: "Next-Day", blurb: "Ready tomorrow (Pickup only)" },
  pre_order: { label: "Pre-Order", blurb: "Pick a date — full custom menu" },
};
